import {FunctionComponent} from 'react';

import {enUS, fr} from 'date-fns/locale';

import {ReactComponent as FrIcon} from '../../assets/svg/fr-flag.svg';
import {ReactComponent as UsaIcon} from '../../assets/svg/usa-flag.svg';

export enum Locales {
    en = 'en',
    fr = 'fr',
}

export const LocaleNames: Record<string, {name: string; icon: FunctionComponent}> = {
    en: {name: 'English', icon: UsaIcon},
    fr: {name: 'French', icon: FrIcon},
};

export const locales: {[id: string]: Locale} = {
    [Locales.en]: enUS,
    [Locales.fr]: fr,
};
